import ErrorBoundary from '@/components/ErrorBoundary';
import { LabradorComponent, StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { withDebugMetadata } from 'lib/utils';
import { getLabStylingClasses } from 'lib/utils/getLabStylingClasses';
import { TextMultiline, TextMultilineProps } from './TextMultiline';

export interface StandaloneTextMultilineProps extends StandaloneComponentProps {
  markup: TextMultilineProps['markup'];
  options?: Omit<TextMultilineProps, 'markup'>;
}

export const StandaloneTextMultiline: StandaloneComponent<StandaloneTextMultilineProps> = ({
  markup,
  options,
  ...props
}) => {
  return (
    <ErrorBoundary>
      <TextMultiline {...{ markup }} {...options} {...props} />
    </ErrorBoundary>
  );
};

export const standalone = StandaloneTextMultiline;

const LabradorTextMultiline: LabradorComponent = ({ type, meta, data, descendants }) => {
  const { bodytext, textAlign, backgroundColor } = data;
  const className = getLabStylingClasses({ backgroundColor, textAlign });

  return <StandaloneTextMultiline markup={bodytext} options={{ className }} {...withDebugMetadata({ type, meta })} />;
};

export default LabradorTextMultiline;
